import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';


const defaultOptions = {
    theme: 'bootstrap4',
    iconlib: "fontawesome4",
    disable_collapse: true,
    compact: true,
    no_additional_properties: true,
    disable_edit_json: true,
    disable_properties: true,
    disable_add_remove: true,
}

const simulationPlaceholders = [
    {
        item: 'name',
        placeholder: 'Name for the simulation configuration'
    },
    {
        item: 'username',
        placeholder: 'Username on target machine'
    },
    {
        item: 'password',
        placeholder: 'Password'
    },
    {
        item: 'host',
        placeholder: 'Hostname or IP Address of target machine'
    },
    {
        item: 'path',
        placeholder: 'Location for the simulation files'
    },
    {
        item: 'sshkey',
        placeholder: 'PEM Key'
    }
]


export default function ConfigurationJsonEditor({ setEditor, options, validation, schema, schemaValues, onChangeJsonEditor, editorId, placeholders }) {

    useEffect(() => {

        const customOptions = { ...defaultOptions, ...options, schema };
        const element = document.getElementById(editorId);
        const jsonEditor = new window.JSONEditor(element, customOptions);

        const formPlaceholders = placeholders != undefined ? placeholders : simulationPlaceholders;

        jsonEditor.on('change', () => {
            const values = jsonEditor.getEditor(`${options.form_name_root}`).getValue();
            onChangeJsonEditor(values);
        });


        jsonEditor.on('ready', () => {
            if (schemaValues) jsonEditor.setValue(schemaValues);
            window.JSONEditor.defaults.custom_validators.push(validation);

            formPlaceholders.forEach((data) => {
                const pathField = document.getElementById(`${options?.form_name_root}[${data.item}]`)

                if (pathField) {
                    pathField.placeholder = data.placeholder
                }
            })
        })

        setEditor(jsonEditor);
        hideFormTitle()
        return () => {
            destryoEditor(jsonEditor);
        }

    }, [schemaValues])

    const destryoEditor = jsonEditor => {
        try {
            jsonEditor.destroy();
        } catch (e) {
            console.eror("json editor error", e)
        }
    }

    const hideFormTitle = () => {
        // console.log("------hideFormTitle--------")
        const element = document.getElementById(editorId);
        // console.log({element})
    }
    return (

        <Grid container spacing={1} xs={12}>
            <Grid item xs={12}>
                <div id={editorId}></div>
            </Grid>
        </Grid>
    )
}